import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InventoryComponent } from './components/inventory.component';
import { loadAssetTypeModuleAsChild } from './asset-types/asset-type/asset-type.module';
import { loadAssetStatusModuleAsChild } from './asset-statuses/asset-status/asset-status.module';
import { loadProviderModuleAsChild } from './providers/provider/provider.module';
import { loadInventoryLocationModuleAsChild } from './inventory-locations/inventory-location/inventory-location.module';
import { loadAssetModelModuleAsChild } from './asset-models/asset-model/asset-model.module';
import { loadLegalDocumentModuleAsChild } from './legal-documents/legal-document/legal-document.module';
import { loadAssetModuleAsChild } from './assets/asset/asset.module';
import { loadMaintenanceCategoryModuleAsChild } from './maintenance-categories/maintenance-category/maintenance-category.module';
import { loadComponentModuleAsChild } from './components/component/component.module';
import { loadAssetComponentModuleAsChild } from './asset-components/asset-component/asset-component.module';
import { loadModelComponentModuleAsChild } from './model-components/model-component/model-component.module';
import { loadNoteModuleAsChild } from './notes/note/note.module';
import { loadEventTypeModuleAsChild } from './event-types/event-type/event-type.module';
import { loadAssetEventModuleAsChild } from './asset-events/asset-event/asset-event.module';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: InventoryComponent,
  },
  { path: 'asset-types', loadChildren: loadAssetTypeModuleAsChild },
  { path: 'asset-statuses', loadChildren: loadAssetStatusModuleAsChild },
  { path: 'providers', loadChildren: loadProviderModuleAsChild },
  { path: 'inventory-locations', loadChildren: loadInventoryLocationModuleAsChild },
  { path: 'asset-models', loadChildren: loadAssetModelModuleAsChild },
  { path: 'legal-documents', loadChildren: loadLegalDocumentModuleAsChild },
  { path: 'assets', loadChildren: loadAssetModuleAsChild },
  { path: 'maintenance-categories', loadChildren: loadMaintenanceCategoryModuleAsChild },
  { path: 'components', loadChildren: loadComponentModuleAsChild },
  { path: 'asset-components', loadChildren: loadAssetComponentModuleAsChild },
  { path: 'model-components', loadChildren: loadModelComponentModuleAsChild },
  { path: 'notes', loadChildren: loadNoteModuleAsChild },
  { path: 'event-types', loadChildren: loadEventTypeModuleAsChild },
  { path: 'asset-events', loadChildren: loadAssetEventModuleAsChild },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InventoryRoutingModule {}
